import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
/** Symbol to signal "pull this field from context" */ export const BiContextProvidedValue = Symbol('BiContextProvidedValue');
/** BiData that supports pulling from context, use for logging from components */ export function BiData(data) {
    return _object_spread_props(_object_spread({}, data), {
        _biLoggerVersion: 2
    });
}
